import { MultiValue, SingleValue } from 'react-select';
import { DropdownSelect } from 'src/components/molecules';
import { Option } from 'src/types';

export interface CaseLeadsDropdownProps {
  currCaseLead: Option;
  availableCaseLeads: Option[];
  onChange: (option: Option) => void;
  'data-testid'?: string;
}

export const CaseLeadsDropdown = ({
  onChange,
  availableCaseLeads,
  currCaseLead,
  ...props
}: CaseLeadsDropdownProps) => {
  const handleOnChange = (option: SingleValue<Option> | MultiValue<Option>) => {
    if (option && 'value' in option && option.value) {
      if (option.value === currCaseLead.value && !onChange) return;
      onChange(option);
    }
  };

  return (
    <DropdownSelect
      {...props}
      options={availableCaseLeads}
      value={currCaseLead}
      onChange={handleOnChange}
    />
  );
};
